<template>
  <div class="userInformation app-content">
    <div class="head-tab">
      <div class="head-box">
        <span>当前位置： </span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">用户信息</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content-box" v-if="!passRevise">
      <div v-if="start == 0">
        <el-tabs v-model="activeName">
          <el-tab-pane label="个人信息" name="0">
            <div class="from-list">
              <el-form :model="personalDataForm" ref="personalDataForm" :rules="personalRule" label-width="100px" class="demo-dynamic">
                <el-form-item
                  prop="name"
                  label="姓名"
                >
                  <el-input placeholder="请输入姓名" v-model="personalDataForm.name"></el-input>
                </el-form-item>
                <el-form-item
                  prop="idCard"
                  label="身份证号"
                >
                  <el-input placeholder="请输入身份证" v-model="personalDataForm.idCard"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                  <el-radio-group v-model="personalDataForm.sex">
                    <el-radio label="女">女</el-radio>
                    <el-radio label="男">男</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!--            <el-form-item-->
                <!--              prop="birthday"-->
                <!--              label="生日"-->
                <!--            >-->
                <!--              <el-input placeholder="请输入生日" v-model="personalDataForm.birthday"></el-input>-->
                <!--            </el-form-item>-->
                <el-form-item
                  prop="phone"
                  label="手机号"
                >
                  <el-input placeholder="请输入手机号" v-model="personalDataForm.phone"></el-input>
                </el-form-item>
                <el-form-item
                  prop="email"
                  label="邮箱"
                >
                  <el-input placeholder="请输入邮箱" v-model="personalDataForm.email"></el-input>
                </el-form-item>
                <el-form-item prop="education" label="学历">
                  <el-select v-model="personalDataForm.education" style="width: 100%" placeholder="请选择学历">
                    <el-option
                      v-for="item in educationList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="identity" label="身份">
                  <el-select v-model="personalDataForm.identity" style="width: 100%" placeholder="请选择身份">
                    <el-option
                      v-for="item in identityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="身份证照片：">
                  <div class="img_upload_line">
                    <div class="img_upload_box cardFront" @click.capture="fileType = 'fd_0'">
                      <el-upload
                        action="/api/renren-fast/app/oss/qiniu/upload"
                        list-type="picture-card"
                        :headers="header"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-change="selectFiles"
                        :on-success="successFiles"
                        title="个人信息页"
                        :file-list="personalDataForm.PhotoFront"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                    <div class="img_upload_box cardBack" @click.capture="fileType = 'fd_1'">
                      <el-upload
                        action="/api/renren-fast/app/oss/qiniu/upload"
                        list-type="picture-card"
                        :headers="header"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-change="selectFiles"
                        :on-success="successFiles"
                        title="国徽页"
                        :file-list="personalDataForm.PhotoReverse"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label-width="0px" class="buttonInfo">
                  <el-button type="primary" @click="saveClick('personalDataForm')">保存</el-button>
                </el-form-item>
              </el-form>
              <div class="img-box">
                <div class="imgII">
                  <img :src="faceImg" alt="">
                </div>
                <div class="img-title">个人头像</div>
                <el-button class="passRevise" type="primary" @click="passReviseClick()">密码修改</el-button>
              </div>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="补贴信息" name="1">-->
<!--            <student-information></student-information>-->
<!--          </el-tab-pane>-->
          <el-tab-pane label="结业信息" name="2">
            <graduation-information></graduation-information>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="start == 1">
        <div class="title">企业信息</div>
        <div class="from-list">
          <el-form :model="enterpriseDataForm" ref="enterpriseDataForm" :rules="enterpriseRule" label-width="100px" class="demo-dynamic">
            <el-form-item
              prop="name"
              label="公司名称"
            >
              <el-input placeholder="请输入公司名称" v-model="enterpriseDataForm.name"></el-input>
            </el-form-item>
            <el-form-item
              prop="email"
              label="企业邮箱"
            >
              <el-input placeholder="请输入企业邮箱" v-model="enterpriseDataForm.email"></el-input>
            </el-form-item>
            <el-form-item
              prop="telephone"
              label="企业电话"
            >
              <el-input placeholder="请输入企业电话" v-model="enterpriseDataForm.telephone"></el-input>
            </el-form-item>
<!--            <el-form-item-->
<!--              prop="address"-->
<!--              label="企业地址"-->
<!--            >-->
<!--              <el-input placeholder="请输入企业地址" v-model="enterpriseDataForm.address"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item
              prop="idCard"
              label="营业执照编号"
            >
              <el-input placeholder="请输入营业执照编号" v-model="enterpriseDataForm.idCard"></el-input>
            </el-form-item>
<!--            <el-form-item-->
<!--              prop="contacts"-->
<!--              label="联系人"-->
<!--            >-->
<!--              <el-input placeholder="请输入联系人" v-model="enterpriseDataForm.contacts"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item-->
<!--              prop="phone"-->
<!--              label="联系人手机"-->
<!--            >-->
<!--              <el-input placeholder="请输入联系人手机" v-model="enterpriseDataForm.phone"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label-width="0px" class="buttonInfo">
              <el-button type="primary" @click="saveClick('enterpriseDataForm')">保存</el-button>
            </el-form-item>
          </el-form>
          <div class="img-box">
            <div class="imgII">
              <img :src="faceImg" alt="">
            </div>
            <div class="img-title">企业头像</div>
            <el-button class="passRevise" type="primary" @click="passReviseClick()">密码修改</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box" v-if="passRevise">
      <div>
        <div class="title">密码修改</div>
        <div class="from-list">
          <el-form :model="passReviseDataForm" ref="passReviseDataForm" :rules="passReviseRule" label-width="100px" class="demo-dynamic">
            <el-form-item
              prop="password"
              label="原始密码"
            >
              <el-input type="password" placeholder="请输入姓名" v-model="passReviseDataForm.password"></el-input>
            </el-form-item>
            <el-form-item
              prop="newPassword"
              label="新密码"
            >
              <el-input type="password" placeholder="请输入新密码" v-model="passReviseDataForm.newPassword"></el-input>
            </el-form-item>
            <el-form-item
              prop="againNewPassword"
              label="确认密码"
            >
              <el-input type="password" placeholder="请确认密码" v-model="passReviseDataForm.againNewPassword"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" class="buttonInfo">
              <el-button type="primary" @click="determineClick('passReviseDataForm')">确定</el-button>
              <el-button type="primary" @click="cancelClick('passReviseDataForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <el-dialog
      title="证件信息"
      :visible.sync="dialogVisible"
      width="390px"
      :before-close="beforeClose">
      <img class="cardImg" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import studentInformation from "../components/studentInformation";
import graduationInformation from "../components/graduationInformation";
export default {
  name: 'userInformation',
  data () {
    let reg = /^1[3456789]\d{9}$/
    let cardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
    let reg1 = /^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$/
    let phoneReg = (rule, value, callback) => {
      if (value !== '' && !reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    let idCardReg = (rule, value, callback) => {
      if (value !== '' && !cardReg.test(value)) {
        callback(new Error('请输入正确的身份证号'))
      } else {
        callback()
      }
    }
    let IDCardReg = (rule, value, callback) => {
      if (value !== '' && !reg1.test(value)) {
        callback(new Error('请输入正确的营业执照'))
      } else {
        callback()
      }
    }
    let password = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passReviseDataForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      personalDataForm: {
        name: '',
        idCard: '',
        sex: '',
        birthday: '',
        phone: '',
        email: '',
        PhotoFront: [],
        PhotoReverse: [],
        education: '',
        identity: '',
        cardJust: '',
        cardBack: ''
      },
      dialogVisible: false,
      dialogImageUrl: '',
      fileType: '',
      personalRule: {
        phone: [{ validator: phoneReg, trigger: 'blur' }],
        idCard: [{ validator: idCardReg, trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]
      },
      enterpriseDataForm: {
        name: '',
        email: '',
        telephone: '',
        address: '',
        idCard: '',
        contacts: '',
        phone: ''
      },
      enterpriseRule: {
        telephone: [{ validator: phoneReg, trigger: 'blur' }],
        // phone: [{ validator: phoneReg, trigger: 'blur' }],
        idCard: [{ validator: IDCardReg, trigger: 'blur' }]
        // email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]
      },
      start: 0,
      passRevise: false,
      passReviseDataForm: {
        password: '',
        newPassword: '',
        againNewPassword: ''
      },
      passReviseRule: {
        password: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        againNewPassword: [{ required: true, message: '请确认密码', trigger: 'blur' },
          { validator: password, trigger: 'blur' }]
      },
      faceImg: require('../assets/img/11-1.png'),
      header: {
        token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''
      },
      activeName: '0',
      educationList: [],
      identityList: []
    }
  },
  components: {
    studentInformation,
    graduationInformation
  },
  mounted () {
    this.start = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).type ? JSON.parse(sessionStorage.getItem('user')).type : 0
    this.getUserInfo()
    this.getEducation()
    this.getIdentity()
  },
  methods: {
    // 选择文件方法
    selectFiles (file, fileList) {
      let _this = this
      console.log(file, fileList)
      if (_this.fileType === 'fd_0') {
        _this.personalDataForm.PhotoFront = fileList
      } else if (_this.fileType === 'fd_1') {
        _this.personalDataForm.PhotoReverse = fileList
      }
    },
    // 文件移除方法
    handleRemove (file, fileList) {
      let _this = this
      if (_this.fileType === 'fd_0') {
        _this.personalDataForm.PhotoFront = []
      } else if (_this.fileType === 'fd_1') {
        _this.personalDataForm.PhotoReverse = []
      }
    },
    // 上传格式校验
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 身份证上传成功
    successFiles (response, file, fileList) {
      let _this = this
      if (_this.fileType === 'fd_0') {
        _this.personalDataForm.cardJust = response.data.viewPath
      } else if (_this.fileType === 'fd_1') {
        _this.personalDataForm.cardBack = response.data.viewPath
      }
    },
    beforeClose () {
      this.dialogVisible = false
    },

    // 获取用户信息
    getUserInfo () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/sys/info/' + JSON.parse(sessionStorage.getItem('user')).userId
      }).then((result) => {
        if (result.data.code === 0) {
          if (this.start === 0) {
            this.personalDataForm = {
              name: result.data.data.userName,
              idCard: result.data.data.shenfen,
              sex: result.data.data.gender === 0 ? '男' : '女',
              phone: result.data.data.telephone,
              email: result.data.data.email,
              PhotoFront: [{url: result.data.data.cardJust}],
              PhotoReverse: [{url: result.data.data.cardBack}],
              cardJust: result.data.data.cardJust,
              cardBack: result.data.data.cardBack,
              education: result.data.data.education,
              identity: result.data.data.identity,
            }
          } else {
            this.enterpriseDataForm = {
              name: result.data.data.userName,
              email: result.data.data.email,
              telephone: result.data.data.telephone,
              idCard: result.data.data.shenfen
            }
          }
          if (result.data.data.faceImg) {
            this.faceImg = result.data.data.faceImg
          }
        } else {
          that.$message.error(result.data.msg)
        }
      })
    },
    saveClick (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          if (that.start === 0) {
            data = {
              'idard_name': that.personalDataForm.name,
              'shenfen': that.personalDataForm.idCard,
              'gender': that.personalDataForm.sex === '女' ? 1 : 0,
              'telephone': that.personalDataForm.phone,
              'email': that.personalDataForm.email,
              'userId': JSON.parse(sessionStorage.getItem('user')).userId,
              'cardJust': that.personalDataForm.cardJust,
              'cardBack': that.personalDataForm.cardBack,
              'education': that.personalDataForm.education,
              'identity': that.personalDataForm.identity,
            }
          } else {
            data = {
              'idard_name': that.enterpriseDataForm.name,
              'email': that.enterpriseDataForm.email,
              'telephone': that.enterpriseDataForm.telephone,
              'shenfen': that.enterpriseDataForm.idCard,
              'type': that.enterpriseDataForm.start,
              'userId': JSON.parse(sessionStorage.getItem('user')).userId,
              'education': that.personalDataForm.education,
              'identity': that.personalDataForm.identity,
            }
          }
          this.$http({
            method: 'POST',
            url: '/api/renren-fast/app/sys/infoupdate',
            data: data
          }).then((result) => {
            console.log(result)
            if (result.data.code === 0) {
              that.getUserInfo()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            } else {
              that.$message.error(result.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //  密码修改功能
    passReviseClick () {
      this.passRevise = true
    },
    // 取消密码修改功能
    cancelClick (formName) {
      this.passRevise = false
      this.$refs[formName].resetFields()
    },
    //  确定密码修改
    determineClick (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            method: 'POST',
            url: '/api/renren-fast/app/sys/password',
            data: {
              newPassword: that.passReviseDataForm.newPassword,
              password: that.passReviseDataForm.password
            }
          }).then((result) => {
            if (result.data.code === 0) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.$router.push('/login')
            } else {
              that.$message.error(result.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取身份信息
    getEducation() {
      let that = this
      that.$http({
        method: 'GET',
        url: '/api/renren-fast/app/sys/getIdentity'
      }).then((result) => {
        if (result.data.code == 0) {
          that.identityList = result.data.data
        }
      })
    },
    // 获取学历信息
    getIdentity() {
      let that = this
      that.$http({
        method: 'GET',
        url: '/api/renren-fast/app/sys/getEducation'
      }).then((result) => {
        if (result.data.code == 0) {
          that.educationList = result.data.data
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.userInformation{
  .head-tab{
    width: 100%;
    background: #f7f7f7;
    .head-box{
      width: 1200px;
      margin: 0 auto;
    }
  }
  .content-box{
    width: 1200px;
    margin: 0 auto 50px;
    .title{
      width: 100%;
      font-size: 20px;
      line-height: 60px;
      border-bottom: 1px solid #999999;
    }
    .from-list{
      display: flex;
      padding: 25px 100px;
      .demo-dynamic{
        width: 500px;
        .buttonInfo{
          width: 100%;
          text-align: center;
          margin-top: 60px;
        }
      }
      .img-box{
        margin-left: 200px;
        .imgII{
          width: 150px;
          height: 200px;
          border-radius: 20px;
          overflow: hidden;
          line-height: 200px;
          img{
            width: 100%;
          }
        }
        .img-title{
          width: 150px;
          margin-top: 5px;
          text-align: center;
        }
        .passRevise{
          margin: 30px 0px 0px 30px;
        }
      }
    }
  }
}
//图片上传
.img_upload_line {
  display: flex;
  .img_upload_box {
    width: 200px;
    height: 129px;
    overflow: hidden;
  }
  .img_example {
    display: flex;
    align-items: center;
    margin: 0 20px;
    cursor: pointer;
    width: 200px;
    height: 150px;
    overflow: hidden;
    position: relative;
    border-radius: 5px;
    &:hover .cover {
      opacity: 1;
    }
    &:hover img {
      filter: blur(3px);
    }
    img {
      width: 100%;
    }
    .cover {
      pointer-events: none;
      text-align: center;
      transition: 0.3s;
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.534);
      i {
        color: white;
        font-size: 25px;
      }
      p {
        font-size: 13px;
        line-height: 20px;
        color: white;
      }
    }
  }
}
.cardImg{
  width: 345px;
  height: 216px;
  border-radius: 10px;
}
</style>
<style>
.img_upload_line .el-upload--picture-card{
  width: 198px;
  height: 127px;
}
.img_upload_line .el-upload-list--picture-card .el-upload-list__item{
  width: 198px;
  height: 127px;
}
.cardFront .el-upload--picture-card{
  background: url("../../static/img/card1.png") no-repeat;
  background-size: 100%;
}
.cardBack .el-upload--picture-card{
  background: url("../../static/img/card2.png") no-repeat;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/userInformation.vue